import { CloseIcon } from "components/atoms/Icon";
import Button from "components/atoms/buttons/Button";
import Modal from "components/atoms/modal";
import { TOOLTIP_HINT_TEXT } from "constants/constants";
import { useState } from "react";
import { toast } from "react-toastify";
import ErrorMessage from "components/atoms/forms/ErrorMessage";
import { ArrowUpTrayIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { TOAST_CONFIG } from "../../../../../constants";

interface IProps {
  open: boolean;
  onClose: () => void;
  handleMakeReleaseWhitelisted: (file: File) => void;
  handleStopWhitelisting: () => void;
  releaseData: Release;
}
const EmptyFileList = new DataTransfer().files;
function ExclusiveReleaseModal({
  open = false,
  onClose,
  handleMakeReleaseWhitelisted,
  handleStopWhitelisting,
  releaseData,
}: IProps) {
  const [file, setFile] = useState<FileList>(EmptyFileList);
  const [errorMessage, setErrorMessage] = useState("");
  const handleSetFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    setErrorMessage("");
    const { files } = e.target;

    if (!files?.length || !files) {
      return toast.error("No file was selected..", TOAST_CONFIG);
    }
    if (files[0].type !== "text/csv") {
      setFile(EmptyFileList);
      setErrorMessage("Select a CSV file.");
      return null;
    }
    setFile(files);
    return null;
  };
  return (
    <Modal open={open} onClose={onClose}>
      <div className="relative rounded-2xl bg-primary p-8 text-white shadow-modal md:w-[600px]">
        <div className="flex justify-between">
          <div className="w-[95%]">
            <h1 className="font-satoshi text-2xl font-bold">
              {releaseData.is_whitelisted ? "Exclusive Release Options" : "Make Release Exclusive:"}
            </h1>
          </div>

          <button type="button" onClick={onClose} className="p-3">
            <CloseIcon className="h-4 w-4 text-white" />
          </button>
        </div>
        <section className="mt-2 w-full font-satoshi text-sm font-450 leading-snug text-white text-opacity-70">
          {TOOLTIP_HINT_TEXT.ReleaseWhitelistingSwitch}
        </section>
        <section className=" mb-3 mt-1">
          <a
            href="https://magnetiq-static.s3.amazonaws.com/media/public/6eb5706b7c1444f596155e785bc53132.csv"
            target="_blank"
            rel="noreferrer"
            className="font-satoshi text-cyan-500 underline hover:text-cyan-300"
          >
            Sample CSV Template
          </a>
        </section>
        <label
          htmlFor="whitelisted-users-csv"
          className="-mb-3 flex w-full cursor-pointer justify-between rounded-ll border-1 border-white bg-primary p-3.5 font-satoshi text-white"
        >
          {file.length === 0
            ? "Click to select CSV file containing emails of Whitelisted Users"
            : `Selected file: ${file[0].name}`}
          <input
            id="whitelisted-users-csv"
            accept=".csv, .CSV"
            onChange={handleSetFile}
            autoComplete="off"
            type="file"
            className="hidden"
          />
        </label>
        <div className="relative -top-6 left-[calc(100%-2rem)] cursor-pointer">
          {file.length === 0 ? (
            <ArrowUpTrayIcon className="pointer-events-none h-5" />
          ) : (
            <XMarkIcon
              className="h-5"
              onClick={() => {
                setFile(EmptyFileList);
              }}
            />
          )}
        </div>
        <ErrorMessage errorMessage={errorMessage} />

        <div className="mt-3 flex justify-end gap-3">
          <Button variant="whiteOutline" text="CANCEL" onClick={onClose} additionalClasses="text-xs" />
          {releaseData.is_whitelisted && (
            <Button
              variant="rustPinkSolid"
              text="STOP WHITELISTING"
              onClick={handleStopWhitelisting}
              additionalClasses="text-xs"
            />
          )}
          <Button
            disabled={file.length === 0}
            variant="magnetiqSolid"
            text={releaseData.is_whitelisted ? "UPDATE" : "CONFIRM"}
            onClick={() => handleMakeReleaseWhitelisted(file[0])}
            additionalClasses="text-xs"
          />
        </div>
      </div>
    </Modal>
  );
}

export default ExclusiveReleaseModal;
